export default "__VITE_ASSET__DGVcAp6H__"